import {
  Box,
  Stack,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@mui/material";
import AdornedInput from "../../../../AdornedInput";
import { toTwoDecimals } from "../../../calculations/utils";
const CoilCalculations = ({
  calculations: calcs,
  variables,
  overrides,
  handleChange,
  resetOverride,
}) => {
  return (
    <>
      {calcs && (
        <Stack direction="column" spacing={2}>
          <Typography>Material</Typography>
          <Stack direction="column" spacing={2}>
            <Stack direction="row" spacing={2}>
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Coil Cost (per Square Feet)"
                value={calcs.costPerSquareFeetOfCoil}
                onChange={handleChange("coil_cost")}
                isOveridden={overrides?.coil_cost}
                handleReset={resetOverride("coil_cost")}
              />
              <AdornedInput
                type="number"
                onWheel={(event) => {
                  event.preventDefault();
                }}
                onFocus={(e) => e.target.select()}
                label="Square Feet Of Coil"
                value={calcs.squareFeetOfCoil}
                onChange={handleChange("square_feet_of_coil_needed_no_waste")}
                isOveridden={overrides?.square_feet_of_coil_needed_no_waste}
                handleReset={resetOverride(
                  "square_feet_of_coil_needed_no_waste"
                )}
              />
            </Stack>
          </Stack>

          <Typography>Cost Breakdown</Typography>
          <Stack direction="row" spacing={2}>
            <AdornedInput
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="Total Coil Cost"
              value={calcs.materialCost}
              symbol="$"
              position="start"
              onChange={handleChange("material_cost")}
              isOveridden={overrides?.material_cost}
              handleReset={resetOverride("material_cost")}
            />
          </Stack>

          <Stack direction="row" spacing={2}>
            <AdornedInput
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="GP %"
              value={
                calcs?.grossProfitMargin
                  ? toTwoDecimals(calcs?.grossProfitMargin * 100.0)
                  : 0
              }
              onChange={(e) => {
                e.target.value = parseFloat(
                  parseFloat(e.target.value).toFixed(4) / 100.0
                ).toFixed(4);
                handleChange("gross_profit_margin")(e);
              }}
              isOveridden={overrides?.gross_profit_margin}
              handleReset={resetOverride("gross_profit_margin")}
              symbol="%"
              position="start"
            />

            <AdornedInput
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="Gross Profit"
              value={calcs.grossProfitDollars}
              symbol="$"
              position="start"
              onChange={handleChange("gross_profit_dollars")}
              isOveridden={overrides?.gross_profit_dollars}
              handleReset={resetOverride("gross_profit_dollars")}
            />
          </Stack>
          <Stack direction="row" spacing={2}>
            <AdornedInput
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="Total Sell Price"
              value={calcs.totalSellPrice}
              symbol="$"
              position="start"
              onChange={handleChange("total_sell_price")}
              isOveridden={overrides?.total_sell_price}
              handleReset={resetOverride("total_sell_price")}
            />
            <AdornedInput
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="Coil Price (per Square Foot)"
              value={calcs.pricePerSquareFeetOfCoil}
              symbol="$"
              position="start"
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
              // onChange={handleChange("coil_price")}
              // isOveridden={overrides?.coil_price}
              // handleReset={resetOverride("coil_price")}
            />

            <AdornedInput
              type="number"
              onWheel={(event) => {
                event.preventDefault();
              }}
              onFocus={(e) => e.target.select()}
              label="Coil Price (per Lineal Foot)"
              symbol="$"
              position="start"
              value={calcs.pricePerLinealFootOfCoil}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
              // onChange={handleChange("coil_price")}
              // isOveridden={overrides?.coil_price}
              // handleReset={resetOverride("coil_price")}
            />
          </Stack>
        </Stack>
      )}
    </>
  );
};
export default CoilCalculations;
